class OnlineUsers extends HTMLElement {
    getOnlineUsers() {
        return this.users && this.users.filter((user) =>
            (
                user.is_online &&
                (!this.currentUserId || parseInt(user.user_id) !== this.currentUserId)
            )
        ) || [];
    }


    updateUsersActivity(payload) {
        this.activity = payload || window.$$projects_activity;
        const users = this.activity[this.projectID];
 
        if (users && users.length) {
            this.users = users;
            this.onlineUsers = this.getOnlineUsers();
            this.setHTML();
        }

        this.style.display = this.onlineUsers.length ? 'block' : 'none';
    }

    setHTML() {
        const itemMarkup = (user) => `<li>
            <img src="https://www.gravatar.com/avatar/${user.gravatar}?s=26&d=identicon" alt="">
            <span>${user.user_name}</span>
        </li>`;
        const listMarkup = this.onlineUsers.map(user => itemMarkup(user)).join('');

        if(this.listElement) {
            this.listElement.innerHTML = `<ul>${listMarkup}</ul>`;
        }
    }

    connectedCallback() {
        this.onlineUsers = [];
        this.currentUserId = window.$$current_user;
        this.activity = window.$$projects_activity;
        this.projectID = this.dataset.projectId;
        this.users = this.activity[this.projectId]
        this.listElement = this.querySelector('.online-users-list');
 
        this.updateUsersActivity();
        window.$eventDispatcher.$on('activity:update', this.updateUsersActivity.bind(this))
    }
}

if (!customElements.get("online-users")) {
    customElements.define("online-users", OnlineUsers);
}